(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    

  class AnnouncementBarSection extends HTMLElement {

    connectedCallback() {

      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(
        this.querySelectorAll('.announcement-bar__slide')
      );

      if (this.slides.length <= 1) return;


      this.currentIndex = this.slides.findIndex(
        (slide) => slide.classList.contains('is-active')
      );


      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      }


      this.isAnimating = false;
      this.animationDuration = 450;


      this.prevButton = this.querySelector(
        '.announcement-bar__button--prev'
      );

      this.nextButton = this.querySelector(
        '.announcement-bar__button--next'
      );


      this.handlePrev = () =>
        this.showSlide(this.currentIndex - 1);

      this.handleNext = () =>
        this.showSlide(this.currentIndex + 1);


      if (this.prevButton) {
        this.prevButton.addEventListener(
          'click',
          this.handlePrev
        );
      }


      if (this.nextButton) {
        this.nextButton.addEventListener(
          'click',
          this.handleNext
        );
      }


      if (
        this.dataset.autoplay === 'true' &&
        !window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {

        this.startAutoplay();

        this.addEventListener(
          'mouseenter',
          this.stopAutoplay.bind(this)
        );

        this.addEventListener(
          'mouseleave',
          this.startAutoplay.bind(this)
        );

      }

    }


    disconnectedCallback() {

      if (this.prevButton) {
        this.prevButton.removeEventListener(
          'click',
          this.handlePrev
        );
      }


      if (this.nextButton) {
        this.nextButton.removeEventListener(
          'click',
          this.handleNext
        );
      }


      this.stopAutoplay();

    }


    showSlide(index) {

      if (this.isAnimating) return;


      const total = this.slides.length;

      const nextIndex =
        (index + total) % total;


      if (nextIndex === this.currentIndex) return;


      const currentSlide =
        this.slides[this.currentIndex];

      const nextSlide =
        this.slides[nextIndex];


      this.isAnimating = true;


      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');

      nextSlide.classList.add('is-active');


      window.setTimeout(() => {

        currentSlide.classList.remove('is-leaving');

        this.currentIndex = nextIndex;

        this.isAnimating = false;

      }, this.animationDuration);

    }


    startAutoplay() {

      this.stopAutoplay();


      const interval =
        Number(this.dataset.interval) || 4000;


      this.autoplayTimer =
        window.setInterval(
          () =>
            this.showSlide(
              this.currentIndex + 1
            ),
          interval
        );

    }


    stopAutoplay() {

      if (this.autoplayTimer) {

        window.clearInterval(
          this.autoplayTimer
        );

        this.autoplayTimer = null;

      }

    }

  }


  if (
    !customElements.get(
      'announcement-bar-section'
    )
  ) {

    customElements.define(
      'announcement-bar-section',
      AnnouncementBarSection
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
